import { useEffect, useState } from "react";
import { api_host } from "../common/globals/constants";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { reportError, reportFetchError } from "../observability/rum";

const KNOWN_STATES = ["sin monitoreo", "umbrales no configurados"];

function getError(err, t) {
  switch (err) {
    case "sin monitoreo":
      return "No hay monitoreos para el rango seleccionado.";
    case "umbrales no configurados":
      return t('apdex.graph.alert.threshold-not-configured');
    default:
      return "Error al cargar los datos.";
  }
}

export function useIndicadorApdex({ objetivoId, periodo, globalStatePeriod }) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    if (objetivoId) {
      fetchPasosObjetivo();
    }
  }, [objetivoId, periodo, globalStatePeriod]);

  async function fetchPasosObjetivo() {
    setIsLoading(true);
    setError("");
    setIsError(false);
    try {
      let token = sessionStorage.getItem("key");
      let user_id = sessionStorage.getItem("user");
      const start = Date.now();
      const { startDate, endDate } = globalStatePeriod;
      const inicio = format(startDate, "yyyy-MM-dd HH:mm");
      const termino = `${format(endDate, "yyyy-MM-dd")} 23:59`;
      await fetch(
        `${api_host}/reporte/online/indicadores/getApdex/?periodo=${periodo}&usuario=${user_id}&token=${token}&objetivo=${objetivoId}&inicio=${inicio}&termino=${termino}&start=${start}`
      )
        .then((response) => response.json())
        .then((myJson) => {
          if (Array.isArray(myJson.pasos)) {
            setData(myJson.pasos);
          } else {
            if (!KNOWN_STATES.includes(myJson.pasos)) {
              reportError(new Error(`getApdex: pasos inesperado: ${myJson.pasos}`), { context: "useIndicadorApdex" });
            }
            setIsError(true);
            setData(null);
            setError(getError(myJson.pasos, t));
          }
        });
    } catch (e) {
      reportFetchError("useIndicadorApdex", e);
      setIsError(true);
      setData(null);
      setError(getError(null, t));
    } finally {
      setIsLoading(false);
    }
  }

  return { data, isLoading, isError, error };
}
